import { useFetch } from './use-fetch';

type IBGEStatesInfo = {
  id: number;
  sigla: string;
  nome: string;
  regiao: {
    id: number;
    sigla: string;
    nome: string;
  };
};

type StateInfo = {
  id: number;
  acronym: string;
  name: string;
  region: {
    id: number;
    acronym: string;
    name: string;
  };
};

const URL_IBGE_STATES = 'https://servicodados.ibge.gov.br/api/v1/localidades/estados';

export function useStates(): StateInfo[] {
  const { data } = useFetch<IBGEStatesInfo[]>(URL_IBGE_STATES);

  return data ? mapStates(data) : [];
}

function mapStates(states: IBGEStatesInfo[]): StateInfo[] {
  return states
    .map(state => ({
      id: state.id,
      acronym: state.sigla,
      name: state.nome,
      region: {
        id: state.regiao.id,
        acronym: state.regiao.sigla,
        name: state.regiao.nome,
      },
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
}
